import { render, staticRenderFns } from "./MindMap.vue?vue&type=template&id=38b50951"
import script from "./MindMap.vue?vue&type=script&lang=js"
export * from "./MindMap.vue?vue&type=script&lang=js"
import style0 from "./MindMap.vue?vue&type=style&index=0&id=38b50951&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports